import HeaderImage from "../img/myked_header_850.png";
import Navbar from "react-bootstrap/Navbar";
import ReactGA from "react-ga";

export default function Header({ activeSection = 'home' }) {
  const trackNavClick = (section, clickSource = 'nav_link') => {
    const scrollY = window.scrollY;
    const viewportHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollPercent = Math.round((scrollY / (documentHeight - viewportHeight)) * 100);
    const currentHash = window.location.hash || 'none';
    
    ReactGA.event({
      category: 'navigation',
      action: 'nav_link_clicked',
      label: `${section}|click_source_${clickSource}|from_section_${activeSection}|scroll_position_${scrollY}px_${scrollPercent}%|current_hash_${currentHash}`,
      value: scrollY
    });
  };
  return (
    <header>
      <Navbar bg="light" fixed="top" id="navbar" className="m-0 p-0">
        <nav
          style={{ justifyContent: "center" }}
          className="navbar navbar-expand-lg"
        >
          <a className="navbar-brand p-3" href="#home" onClick={() => trackNavClick('home', 'brand_logo')}>
            <img src={HeaderImage} className="img-responsive" alt="Myke D - Creative Developer & Game Designer Portfolio Header" />
          </a>

          <ul
            style={{ justifyContent: "center" }}
            className="navbar-nav mr-auto mt-2 mt-lg-0"
          >
            <li className="nav-item">
              <a 
                className={`nav-link ${activeSection === 'home' ? 'active-scroll-spy' : ''}`} 
                href="#home"
                onClick={() => trackNavClick('home')}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'about' ? 'active-scroll-spy' : ''}`}
                href="#about"
                onClick={() => trackNavClick('about')}
              >
                About
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'projects' ? 'active-scroll-spy' : ''}`}
                href="#projects"
                onClick={() => trackNavClick('projects')}
              >
                Projects
              </a>
            </li>
            <li className="nav-item">
              <a
                className={`nav-link ${activeSection === 'contact' ? 'active-scroll-spy' : ''}`}
                href="#contact"
                onClick={() => trackNavClick('contact')}
              >
                Contact
              </a>
            </li>
          </ul>
        </nav>
      </Navbar>
    </header>
  );
}
